import * as React from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Action, Secondary} from '../../system/buttons';
import {Modal, Spinner} from 'react-bootstrap';
import {useState} from 'react';
import PulsoidClient from '../../PulsoidClient';
import {
  DISCONNECT_CLIENTS,
  IsFeatureEnabled,
} from '../../system/FeatureDisabler';

const ClientCard = ({client, onDisconnect}) => {
  const [modal, setModal] = useState(false);
  const [disconnecting, setDisconnecting] = useState(false);
  return (
    <Card
      id={client.id}
      style={{
        width: '15rem',
        height: '15rem',
        margin: '5px',
        border: '1px solid rgba(0,0,0,.125)',
      }}
      className="text-center"
      key={client.id}
    >
      <Card.Body style={{height: '100%', textAlign: 'center'}}>
        <Card.Subtitle className="mb-2" key={1}>
          {client.name}
        </Card.Subtitle>
        <Card.Subtitle key={2} style={{fontSize: '10px'}}>
          {client.ownedByPulsoid
            ? 'operated by Pulsoid'
            : '3rd party application'}{' '}
        </Card.Subtitle>
        <div style={{height: '8em'}}>
          <img
            src={client.logoUrl}
            style={{maxHeight: '80%'}}
            alt={'Loading...'}
          />
        </div>

        <Row>
          <Col>
            <Secondary onClick={() => setModal(!modal)}>Disconnect</Secondary>
          </Col>
        </Row>

        <Modal show={modal} centered={true} onHide={() => setModal(false)}>
          <Modal.Header closeButton>
            Are you sure you want to disconnect {client.name}?
          </Modal.Header>
          <Modal.Footer>
            <Secondary variant="secondary" onClick={() => setModal(false)}>
              Close
            </Secondary>
            <Action
              variant="primary"
              onClick={async () => {
                setDisconnecting(true);
                await new PulsoidClient().revokeTokens(client.id);
                setDisconnecting(false);
                setModal(false);
                onDisconnect();
              }}
            >
              {disconnecting ? <Spinner size="sm" animation="border" /> : ''}
              {disconnecting ? 'Disconnecting...' : 'Disconnect'}
            </Action>
          </Modal.Footer>
        </Modal>
      </Card.Body>
    </Card>
  );
};

export const processClients = (clients, onDisconnect) => {
  if (IsFeatureEnabled(DISCONNECT_CLIENTS)) {
    let processed = [];
    clients.forEach((client, index) => {
      processed.push(
        <ClientCard key={index} client={client} onDisconnect={onDisconnect} />
      );
    });
    return processed;
  } else {
    return [];
  }
};
